import { WEEKDAYS, MAX_MONTHS, MONTH, STATE_MONTHS } from '@app/src/common/datePicker/state/calendar/constants';
import { DayType } from '@app/src/common/datePicker/types/Day';
import { DateType } from '@app/src/common/datePicker/types/Date';

export const getPrevDate = ({ month, year }: DateType): DateType => {
  if(month > MONTH.FIRST) {
    return {
      month: month - 1,
      year
    }
  }
  return {
    month: MONTH.LAST,
    year: year - 1
  }
};

export const getNextDate = ({ month, year }: DateType): DateType => {
  if(month < MONTH.LAST) {
    return {
      month: month + 1,
      year
    };
  }
  return {
    month: MONTH.FIRST,
    year: year + 1
  };
};


const getTotalDays = (month: number, year: number): number => {
  return 32 - new Date(year, month, 32).getDate();
};

const getFirstDay = (month: number, year: number): number => {
  const firstDay: number = new Date(year, month).getDay() - 1;
  return firstDay < 0 ? 6 : firstDay;
};

export const getCalendar = (printData) => {
  const { id } = printData;
  const calendar = [];
  let month = new Date().getMonth();
  let year = new Date().getFullYear();
  for(let i = 1; i <= MAX_MONTHS; i++) {
    calendar.push(getDaysByMonth(month, year, i-1));
    if (month % 11 === 0 && month !== 0) {
      year++;
    }
    month++;
  }
  return getValidateDateByPrint[id](calendar, printData);
};

const validPosition = (currentMonth: number) => currentMonth % 12;

const getDaysByMonth = (currentMonth: number, year: number, positionMonth: number): DayType[] => {
  const daysMonth = [];
  let initialDay: number = 1;
  const endCurrentMonth = validPosition(currentMonth);
  const endPrevMonth = (validPosition(currentMonth) === 0) ? 11 : validPosition(currentMonth) - 1;
  const endNextMonth = (validPosition(currentMonth) === 11) ? 0 : validPosition(currentMonth) + 1;
  const prevMonthDay: Date = new Date(year, endCurrentMonth, 0);
  let daysPrevMonth = prevMonthDay.getDate();
  const rowsByMonth: number = 6;
  const weekDays: number = 6;
  const firstDay: number = getFirstDay(currentMonth, year);
  let dayNextMonth = 1;
  let dayPrevMonth = 1;

  for(let i = 0; i < rowsByMonth; i++) {
    for(let j = 0; j <= weekDays; j++) {
      if(i === 0 && j < firstDay) {
        const daysPrev = firstDay > 0 ? daysPrevMonth - firstDay + dayPrevMonth : daysPrevMonth;
        dayPrevMonth++;
        daysMonth.push({
          stateMonth: STATE_MONTHS.PREV,
          dayMonth: daysPrev,
          dayName: WEEKDAYS[j],
          disabled: setDisabledDaysByBehaviorCalendar(STATE_MONTHS.PREV, endPrevMonth, daysPrev, positionMonth),
          dayWeekPos: j,
          otherDayMonth: true,
          month: endPrevMonth,
          year: validPosition(currentMonth) === 0 ? year - 1 : year
        });
        continue;
      }
      if (initialDay > getTotalDays(currentMonth, year)) {
        const daysNext = dayNextMonth++;
        daysMonth.push({
          stateMonth: STATE_MONTHS.NEXT,
          dayMonth: daysNext,
          dayName: WEEKDAYS[j],
          disabled: setDisabledDaysByBehaviorCalendar(STATE_MONTHS.NEXT, endNextMonth, daysNext, positionMonth),
          dayWeekPos: j,
          otherDayMonth: true,
          month: endNextMonth,
          year: (validPosition(currentMonth) === 11) ? year + 1 : year
        });
        continue;
      }
      daysMonth.push({
        dayMonth: initialDay,
        stateMonth: STATE_MONTHS.CURRENT,
        dayName: WEEKDAYS[j],
        disabled: setDisabledDaysByBehaviorCalendar(STATE_MONTHS.CURRENT, endCurrentMonth, initialDay, positionMonth),
        dayWeekPos: j,
        otherDayMonth: false,
        month: endCurrentMonth,
        year: year
      });
      initialDay++;
    }
  }
  return daysMonth;
};

const setDisabledDaysByBehaviorCalendar = (stateMonth: string, month: number, dayMonth: number, posMonth: number) => {
  const currentDay = new Date().getDate();
  const currentMonth = new Date().getMonth();

  if (stateMonth === STATE_MONTHS.CURRENT && dayMonth < currentDay && posMonth === 0 ) {
    return true;
  }
  if (stateMonth === STATE_MONTHS.PREV && (currentMonth - 1 === month || currentMonth - 1 < 0) ) {
      return true;
  }
  if (posMonth === MAX_MONTHS - 1 && stateMonth === STATE_MONTHS.NEXT) {
    return true;
  }
  return false;
};

const isToday = (day: DayType) => {
  const currentDay = new Date().getDate();
  const currentMonth = new Date().getMonth();
  const currentYear = new Date().getFullYear();
  return day.dayMonth === currentDay && day.month === currentMonth && day.year === currentYear;
};

const validateDatePublicationTimeTalanD = (calendar: any, printData: any) => {
  const { allowDay, closeDay, closeHour } = printData;
  const dayPosition =  new Date().getDay();
  const currentDayPosition = dayPosition - 1 < 0 ? 6 : dayPosition - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (
        !calendar[i][j].disabled &&
        (calendar[i][j].dayWeekPos === allowDay)
      ) {
        calendar[i][j].disabled = false;
      } else {
        calendar[i][j].disabled = true;
      }

      if (
        isToday(calendar[i][j])
      ) {
          if (currentDayPosition === closeDay && currentHour >= closeHour) {
            calendar[i][j + 3].disabled = true;
          }
          if (currentDayPosition > closeDay){
            if (currentDayPosition === 4) {
              calendar[i][j+2].disabled = true;
            }
            if (currentDayPosition === 5) {
              calendar[i][j+1].disabled = true;
            }
            if (currentDayPosition === 6) {
              calendar[i][j].disabled = true;
            }
          }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeComercioMS = (calendar: any, printData: any) => {
  const { closeDay, closeHour, allowDay } = printData;
  const currentDayPosition = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (!calendar[i][j].disabled) {
        if (allowDay.includes(calendar[i][j].dayWeekPos)) {
          calendar[i][j].disabled = false;
        } else {
          calendar[i][j].disabled = true;
        }
      }

      if (
        isToday(calendar[i][j])
      ) {
        let pos = allowDay.indexOf(currentDayPosition);
        let currentDay;
        let acBefore = pos;
        let acAfter = 1;
        if (pos >= 0) {
          for(let c=0; c<allowDay.length; c++) {
            if (c<pos) {
              currentDay = calendar[i][j - acBefore];
              acBefore--;
            }
            if (c===pos) {
              currentDay = calendar[i][j];
            }
            if (c>pos) {
              currentDay = calendar[i][j + acAfter];
              acAfter++;
            }
            if (!currentDay.disabled) {
              if (currentDayPosition > closeDay[c]) {
                currentDay.disabled = true;
              }
              if (currentDayPosition === closeDay[c] && currentHour >= closeHour[c]) {
                currentDay.disabled = true;
              }
              if (currentDayPosition === 4 && allowDay[c] === 5 ) {
                currentDay = calendar[i][j + 3];
                if (currentHour >= closeHour[0]) {
                  currentDay.disabled = true;
                }
              }
              if (currentDayPosition === 5) {
                currentDay = calendar[i][j + 2];
                currentDay.disabled = true;
              }
            }
          }
        } else {
          if (currentDayPosition === 6) {
            currentDay = calendar[i][j + 1];
            if (!currentDay.disabled) {
              currentDay.disabled = true;
            }
          }
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeComercioD = (calendar: any, printData: any) => {
  const { allowDay, closeDay, closeHour } = printData;
  const dayPosition =  new Date().getDay();
  const currentDayPosition = dayPosition - 1 < 0 ? 6 : dayPosition - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (
        !calendar[i][j].disabled &&
        (calendar[i][j].dayWeekPos === allowDay)
      ) {
        calendar[i][j].disabled = false;
      } else {
        calendar[i][j].disabled = true;
      }

      if (
        isToday(calendar[i][j])
      ) {
          if (currentDayPosition === closeDay && currentHour >= closeHour) {
            calendar[i][j + 2].disabled = true;
          }
          if (currentDayPosition > closeDay){
            if (currentDayPosition === 5) {
              calendar[i][j+1].disabled = true;
            }
            if (currentDayPosition === 6) {
              calendar[i][j].disabled = true;
            }
          }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeTalanS = (calendar: any, printData: any) => {
  const { allowDay, closeDay, closeHour } = printData;
  const dayPosition =  new Date().getDay();
  const currentDayPosition = dayPosition - 1 < 0 ? 6 : dayPosition - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (
        !calendar[i][j].disabled &&
        (calendar[i][j].dayWeekPos === allowDay)
      ) {
        calendar[i][j].disabled = false;
      } else {
        calendar[i][j].disabled = true;
      }

      if (
        isToday(calendar[i][j])
      ) {
          if (currentDayPosition === closeDay && currentHour >= closeHour) {
            calendar[i][j + 3].disabled = true;
          }
          if (currentDayPosition > closeDay){
            if (currentDayPosition === 3) {
              calendar[i][j+2].disabled = true;
            }
            if (currentDayPosition === 4) {
              calendar[i][j+1].disabled = true;
            }
            if (currentDayPosition === 5) {
              calendar[i][j].disabled = true;
            }
            if (currentDayPosition === 6) {
              calendar[i][j - 1].disabled = true;
            }
          }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeTalanLV = (calendar: any, printData: any) => {
  const { closeDay, closeHour, allowDay } = printData;
  const currentDayPosition = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (!calendar[i][j].disabled) {
        if (allowDay.includes(calendar[i][j].dayWeekPos)) {
          calendar[i][j].disabled = false;
        } else {
          calendar[i][j].disabled = true;
        }
      }

      if (
        isToday(calendar[i][j])
      ) {
        let pos = allowDay.indexOf(currentDayPosition);
        let currentDay;
        let acBefore = pos;
        let acAfter = 1;
        if (pos >= 0) {
          for(let c=0; c<allowDay.length; c++) {
            if (c<pos) {
              currentDay = calendar[i][j - acBefore];
              if (closeDay[c] > currentDayPosition) {
                currentDay = calendar[i][j - acBefore + 7];
              }
              acBefore--;
            }
            if (c===pos) {
              currentDay = calendar[i][j];
            }
            if (c>pos) {
              currentDay = calendar[i][j + acAfter];
              acAfter++;
            }
            if (!currentDay.disabled) {
              if (currentDayPosition > closeDay[c]) {
                currentDay.disabled = true;
              }
              if (currentDayPosition === closeDay[c] && currentHour >= closeHour[c]) {
                currentDay.disabled = true;
              }
              if (currentDayPosition === 0) {
                calendar[i][j + 1].disabled = true;
                console.log(calendar[i][j], 'dau')
              }
              if (currentDayPosition === 1) {
                calendar[i][j].disabled = true;
                calendar[i][j - 1].disabled = true;
              }
              if (currentDayPosition === 4 && allowDay[c] === 4 ) {
                currentDay = calendar[i][j + 3];
                if (currentHour >= closeHour[0]) {
                  currentDay.disabled = true;
                }
              }
            }
          }
        } else {
          if (currentDayPosition === 5) {
            calendar[i][j + 2].disabled = true;
          }
          if (currentDayPosition === 6 ) {
            calendar[i][j + 1].disabled = true;
            if (currentHour >= closeHour[1]) {
              calendar[i][j + 2].disabled = true;
            }
          }
        }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeDeporSD = (calendar: any, printData: any) => {
  const { closeDay, closeHour, allowDay } = printData;
  const currentDayPosition = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (!calendar[i][j].disabled) {
        if (allowDay.includes(calendar[i][j].dayWeekPos)) {
          calendar[i][j].disabled = false;
        } else {
          calendar[i][j].disabled = true;
        }
      }

      if (
        isToday(calendar[i][j])
      ) {
          if (currentDayPosition === closeDay[0] && currentHour >= closeHour[0]) {
            calendar[i][j + 2].disabled = true;
          }
          if (currentDayPosition === closeDay[1]) {
            calendar[i][j + 1].disabled = true;
            if (currentHour >= closeHour[1]) {
              calendar[i][j + 2].disabled = true;
            }
          }
          if (currentDayPosition > closeDay[1]){
            if (currentDayPosition === 5) {
              calendar[i][j].disabled = true;
              calendar[i][j+1].disabled = true;
            }
            if (currentDayPosition === 6) {
              calendar[i][j].disabled = true;
              calendar[i][j-1].disabled = true;
            }
          }
      }
    }
  }

  return calendar;
};

const validateDatePublicationTimeDeporLV = (calendar: any, printData: any) => {
  const { closeDay, closeHour, allowDay } = printData;
  const currentDayPosition = new Date().getDay() - 1 < 0 ? 6 : new Date().getDay() - 1;
  const currentHour = new Date().getHours();

  for (let i = 0; i < calendar.length; i++) {
    for (let j = 0; j < calendar[i].length; j++) {
      if (!calendar[i][j].disabled) {
        if (allowDay.includes(calendar[i][j].dayWeekPos)) {
          calendar[i][j].disabled = false;
        } else {
          calendar[i][j].disabled = true;
        }
      }

      if (
        isToday(calendar[i][j])
      ) {
        let pos = allowDay.indexOf(currentDayPosition);
        let currentDay;
        let acBefore = pos;
        let acAfter = 1;
        if (pos >= 0) {
          for(let c=0; c<allowDay.length; c++) {
            if (c<pos) {
              currentDay = calendar[i][j - acBefore];
              if (closeDay[c] > currentDayPosition) {
                currentDay = calendar[i][j - acBefore + 7];
              }
              acBefore--;
            }
            if (c===pos) {
              currentDay = calendar[i][j];
            }
            if (c>pos) {
              currentDay = calendar[i][j + acAfter];
              acAfter++;
            }
            if (!currentDay.disabled) {
              if (currentDayPosition > closeDay[c]) {
                currentDay.disabled = true;
              }
              if (currentDayPosition === closeDay[c] && currentHour >= closeHour[c]) {
                currentDay.disabled = true;
              }
              if (currentDayPosition === 0) {
                calendar[i][j + 1].disabled = true;
              }
              if (currentDayPosition === 1) {
                calendar[i][j - 1].disabled = true;
              }
              if (currentDayPosition === 4 && allowDay[c] === 4 ) {
                currentDay = calendar[i][j + 3];
                if (currentHour >= closeHour[0]) {
                  currentDay.disabled = true;
                }
              }
            }
          }
        } else {
          if (currentDayPosition === 5) {
            calendar[i][j + 2].disabled = true;
          }
          if (currentDayPosition === 6 ) {
            calendar[i][j + 1].disabled = true;
            if (currentHour >= closeHour[1]) {
              calendar[i][j + 2].disabled = true;
            }
          }
        }
      }
    }
  }

  return calendar;
};

export const getValidateDateByPrint = {
  1: validateDatePublicationTimeComercioD,
  2: validateDatePublicationTimeTalanD,
  3: validateDatePublicationTimeComercioMS,
  4: validateDatePublicationTimeTalanS,
  5: validateDatePublicationTimeTalanLV,
  6: validateDatePublicationTimeDeporSD,
  7: validateDatePublicationTimeDeporLV
};

